<div class="visits-popup-wrapper">
  <router-outlet></router-outlet>
</div>
